import { render, staticRenderFns } from "./ControlComment.vue?vue&type=template&id=4fe93563&scoped=true&"
import script from "./ControlComment.vue?vue&type=script&lang=js&"
export * from "./ControlComment.vue?vue&type=script&lang=js&"
import style0 from "./ControlComment.vue?vue&type=style&index=0&id=4fe93563&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe93563",
  null
  
)

export default component.exports